import { useEffect } from 'react';
import { useToast } from '@chakra-ui/react';
import { useStore } from '@tanstack/react-store';
import {   
  notificationStore,
  clearToast 
} from '@/store';
import {
  ToastComponent
} from "./toast-component";

export const AppToastComponent = () => {
  const { title, description, severity, duration } = useStore(notificationStore);
  const toast = useToast();

  useEffect(() => {
    if (title) {
      toast({
        duration: duration,
        isClosable: true,
        render: () => (
          <ToastComponent
            title={title}
            description={description || undefined}
            status={severity || 'info'}
          />
        ),
      });
      clearToast();
    }
  }, [title, description, severity, duration, toast]);

  return null;
};